import useAppStore from "@/stores/app";
import useSessionStore from "@/stores/session";

export default function useStore() {
  return {
    app: useAppStore(),
    session: useSessionStore()
  };
}
